import { useField } from "formik"
import { DynamicConfigField, DynamicConfigKey, PaymentMethodOptionValue } from "./formTypes"
import { PaymentMethodType } from "../../../../../modules/payments/paymentTypes"
import { SelectedMainUserState } from "../../../createOrder/createOrderTypes"
import { isAccountingDimensionKey } from "./helpers"
import { DynamicFormField } from "./DynamicFormField"

type AccountingDimensionControllerProps = {
    config: DynamicConfigField
    user?: SelectedMainUserState
}

export function AccountingDimensionController({ config, user }: AccountingDimensionControllerProps) {
    const [{ value: paymentMethodFieldValue }] = useField(DynamicConfigKey.PAYMENT_METHOD)
    const paymentValue: PaymentMethodOptionValue = paymentMethodFieldValue?.value

    if (isAccountingDimensionKey(config.key) && paymentValue !== PaymentMethodType.INVOICE) return null

    return <DynamicFormField config={config} user={user} />
}
